import React from 'react'

const Referral = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M11.0474 15.0012C9.54159 13.489 9.67757 10.9007 11.3503 9.22154L16.1977 4.35499C17.8704 2.6748 20.4471 2.53878 21.9539 4.04995C23.4597 5.56212 23.3237 8.15041 21.6509 9.8306L19.2272 12.2639" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8"></path>
<path d="M14.9526 10.999C16.4584 12.5112 16.3225 15.0995 14.6497 16.7787L12.226 19.2119L9.80236 21.6452C8.12959 23.3254 5.55295 23.4614 4.04616 21.9503C2.54037 20.4381 2.67635 17.8498 4.34912 16.1696L6.77278 13.7363" opacity="0.5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8"></path>
</svg>
    )
}

export default Referral
